var VideoPlayer = function(element, options) {
  var self = this;

  var defaults = {
    'video'        : '.video-fullwidth__video-embed',
    'toggle'       : '.video-fullwidth__play-button',
    'playPause'    : '.video-fullwidth__play-pause-button',
    'close'        : '.video-fullwidth__video-close',
    'content'      : '.video-fullwidth__content',
    'placeholder'  : '.video-fullwidth__video-placeholder',
  };

  var settings = $.extend({}, defaults, options);

  var selectorOrJQuery = function(elem){
    if (typeof elem == 'string') {
      return $(element).find(elem).first();
    } else if (typeof elem === 'object') {
      return elem;
    }
  };

  this.element = $(element);
  this.video = selectorOrJQuery(settings.video);
  this.toggle = selectorOrJQuery(settings.toggle);
  this.playPause = selectorOrJQuery(settings.playPause);
  this.close = selectorOrJQuery(settings.close);
  this.content = selectorOrJQuery(settings.content);
  this.placeholder = selectorOrJQuery(settings.placeholder);
  this.id = 'vid' + Math.floor(Math.random() * 21) + Date.now();
  this.YTplayer = null;
  this.player = null;
  this.loaded = false;
  this.ytid = null;

  this.init = function() {
    if($(self.video).hasClass('vimeo')){
      self.attachVimeoEvents();
    }else{
      if (typeof window.App.VideoPlayer == 'undefined') {
        window.App.VideoPlayer = {};
      };
      window.App.VideoPlayer[self.id] = self;

      if (typeof window.onYouTubeIframeAPIReady == 'undefined') {
        $.getScript( "https://www.youtube.com/iframe_api");
        window.onYouTubeIframeAPIReady = function(){
          self.setupIFrame();
        };
      }

      self.loadPlayer();
      self.attachEvents();
    }
  };

  this.loadPlayer = function() {
    self.player = $(self.video).find('.iframe').first();
    self.ytid = self.player.data('url').replace(/^.*?v=/, '');
    self.player.first().attr('id', self.ytid);
  }

  this.setupIFrame = function() {
    $.each(window.App.VideoPlayer, function(index, element){
      element.YTplayer = new YT.Player(element.ytid, {
        videoId: element.ytid,
        playerVars: {
          modestbranding: 1,
          iv_load_policy: 3,
          enablejsapi: 1,
          controls: 1,
          playsinline: 0,
          rel: 0,
          showinfo: 0
        },
        events: {
          onReady: element.onPlayerReady,
          onStateChange: element.onPlayerStateChange
        }
      });
    })
  }

  this.onPlayerReady = function() {
    window.App.VideoPlayer[self.id].loaded = true;
  }

  this.onPlayerStateChange = function(e) {
    var d = e.data;
    if (d == 1 || d == 3) {
      $(self.playPause).removeClass('video__play-pause-button--paused');
    }
    if (d == 0 || d == 2 || d == 5) {
      $(self.playPause).addClass('video__play-pause-button--paused');
    }
  }

  this.attachEvents = function() {
    self.toggle.on('click', function(e){
      e.preventDefault();
      if (window.App.VideoPlayer[self.id].loaded === true) {
        window.App.VideoPlayer[self.id].showVideo();
        window.App.VideoPlayer[self.id].playVideo();
      }
    });

    self.playPause.on('click', function(e){
      e.preventDefault();
      if ($(self.playPause).hasClass('video__play-pause-button--paused')){
        window.App.VideoPlayer[self.id].playVideo();
      } else {
        window.App.VideoPlayer[self.id].pauseVideo();
      }
    });

    self.close.on('click', function(e){
      e.preventDefault();
      window.App.VideoPlayer[self.id].hideVideo();
      window.App.VideoPlayer[self.id].pauseVideo();
    })
  }

  this.showVideo = function() {
    self.video.addClass(settings.video.replace(/\./, '')+'--active');
    self.content.addClass(settings.content.replace(/\./, '')+'--hidden');
    self.placeholder.addClass(settings.placeholder.replace(/\./, '')+'--hidden');
    $(self.element).addClass('video--playing');
  };

  this.playVideo = function() {
    self.YTplayer.playVideo();
    $(self.playPause).removeClass('video__play-pause-button--paused');
  }

  this.pauseVideo = function() {
    self.YTplayer.pauseVideo();
    $(self.playPause).addClass('video__play-pause-button--paused');
  }

  this.hideVideo = function() {
    self.video.removeClass(settings.video.replace(/\./, '')+'--active');
    self.content.removeClass(settings.content.replace(/\./, '')+'--hidden');
    self.placeholder.removeClass(settings.placeholder.replace(/\./, '')+'--hidden');
    $(self.element).removeClass('video--playing');
  };

  this.attachVimeoEvents = function() {
    self.toggle.on('click', function(e){
      e.preventDefault();
      self.video.addClass(settings.video.replace(/\./, '')+'--active');
      self.content.addClass(settings.content.replace(/\./, '')+'--hidden');
      self.placeholder.addClass(settings.placeholder.replace(/\./, '')+'--hidden');
      $(self.element).addClass('video--playing');
    });

  }

  this.init();
};
